import { Button, Card, Empty, Space, Spin, Typography } from 'antd';
import { useState } from 'react';
import { useListTeamClients } from 'client/modules/external-api/hooks/queries/external-api';
import { ApiApplication } from '@cbinsights/externalapiservice/externalapiservice';
import { CreateClientButton } from 'client/modules/external-api/components/CreateClientButton';
import useGetTeamQuery from 'client/modules/team/services/hooks/useGetTeamQuery';
import { TeamDataFeedConfigList } from '../components/TeamDataFeedConfigList';
import { CreateDataFeedModal } from '../components/CreateDataFeedModal';

const { Title, Text } = Typography;

const NoClientMessage = ({
  idTeam,
  teamCredits,
}: {
  idTeam: number;
  teamCredits: number;
}) => {
  const { data: teamResponse, isLoading } = useGetTeamQuery({
    enabled: true,
    params: { id_team: idTeam },
  });

  return (
    <Card className="text-center">
      <Space direction="vertical" size="large">
        <Empty description={false} />
        <Title level={4}>No client available</Title>
        <Text type="secondary">
          To continue, create a new client for the API.
        </Text>
        <CreateClientButton
          idTeam={idTeam}
          name={teamResponse?.team?.name || ''}
          disabled={isLoading}
          preselectedApplication={ApiApplication.API_APPLICATION_DATAFEEDS}
          initialCredits={teamCredits}
        />
      </Space>
    </Card>
  );
};

type TeamDataFeedListProps = {
  idTeam: number;
};

export const TeamDataFeedList = ({ idTeam }: TeamDataFeedListProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: teamClientData, isLoading } = useListTeamClients(idTeam);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <Spin size="large" />
      </div>
    );
  }

  const credits = Number(teamClientData?.clients[0]?.available_credits) || 0;
  const teamName = teamClientData?.clients[0]?.team_name || '';

  const hasDataFeedClient =
    teamClientData?.clients?.filter(
      (el) => el.api_application === ApiApplication.API_APPLICATION_DATAFEEDS
    ).length > 0;

  if (!hasDataFeedClient) {
    return <NoClientMessage idTeam={idTeam} teamCredits={credits} />;
  }

  return (
    <div>
      <div className="flex justify-end mb-4">
        <Button
          type="primary"
          className="bg-blue-500"
          onClick={() => setIsModalOpen(true)}
        >
          Create data feed
        </Button>
      </div>
      <TeamDataFeedConfigList idTeam={idTeam.toString()} />
      <CreateDataFeedModal
        open={isModalOpen}
        onExit={() => setIsModalOpen(false)}
        teamName={teamName}
        idTeam={idTeam.toString()}
      />
    </div>
  );
};
